<template>
	<div>
		<template v-if="mainComponent">
			<component :is="mainComponent" v-bind:cfg="mainComponentProperties"></component>
			<!-- BĖDA! Lyg ir visi komponentai kraunasi iškart? Gal reikia nenaudoti :is? Gal čia išvardinti visus komponentus naudojant v-if? -->
		</template>
		<template v-else-if="loginError">
			<v-app>
				<div class="ma-3">{{loginError}}</div>
			</v-app>
		</template>
		<template v-else>
			<v-app>
				<v-progress-circular
					indeterminate
					color="primary"
					:size="40"
					width="2"
					class="ma-3"
				></v-progress-circular>
			</v-app>
		</template>
	</div>
</template>

<script>
	import CommonHelper from "./components/helpers/CommonHelper";
	import Loading from "./components/Loading";
	import "whatwg-fetch"; // Prireikė IE fetch'ui...

	export default {
		name: "App",
		components: {
			"admin": () => ({
				component: import("./components/main/Admin"),
				loading: Loading
			}),
			"atlas": () => ({
				component: import("./components/main/Atlas"),
				loading: Loading
			}),
			"atlas-summary": () => ({
				component: import("./components/main/AtlasSummary"),
				loading: Loading
			}),
			"gallery": () => ({
				component: import("./components/main/Gallery"),
				loading: Loading
			}),
			"index": () => ({
				component: import("./components/main/Index"),
				loading: Loading
			}),
			"my-content": () => ({
				component: import("./components/main/MyContent"),
				loading: Loading
			})
		},
		methods: {
			routeTo(path){
				CommonHelper.getUserData().then(function(userData){
					var mainComponent,
						mainComponentProperties,
						allowAnonymous = false;
					switch (path) {
						case "/":
							mainComponent = "index";
							allowAnonymous = true;
							break;
						case "/my-content":
						case "/my-content/":
							mainComponent = "my-content";
							break;
						case "/admin":
						case "/admin/":
							if (CommonHelper.isUserAdmin()) {
								mainComponent = "admin";
							}
							break;
						case "/gallery":
						case "/gallery/":
							mainComponent = "gallery";
							allowAnonymous = true;
							break;
						default:
							var atlasPathData = CommonHelper.getAtlasPathData(path);
							if (atlasPathData) {
								if (atlasPathData[1]) {
									mainComponentProperties = {
										mode: atlasPathData[1]
									};
									mainComponent = "atlas";
									allowAnonymous = true;
								} else {
									mainComponent = "atlas-summary";
									allowAnonymous = true;
								}
							}
					}
					if (userData.anonymous && !allowAnonymous) {
						// this.loginError = "Anoniminiams vartotojams prieiga uždrausta";
						this.mainComponent = null; // Aktualu anoniminiams vartotojams, kurie pereina iš leidžiamo peržiūrai puslapį į neleidžiamą...
						var loginUrl = "https://" + window.location.host + "/leip.sso/Login" + "?target=" + encodeURIComponent(window.location.href);
						window.location = loginUrl;
					} else {
						if (mainComponent) {
							this.mainComponent = mainComponent;
							this.mainComponentProperties = mainComponentProperties;
						} else {
							this.$router.replace("/");
						}
					}
				}.bind(this), function(){
					this.loginError = "Prisijungimo klaida...";
				}.bind(this));
			},
			createSessionManager: function(){
				this.checkSession();
			},
			checkSession: function(){
				if (CommonHelper.sessionUrl) {
					var timeGap = 120000; // 2 minutėlės
					setTimeout(function(){
						window.fetch(CommonHelper.sessionUrl, {
							method: "GET",
							headers: {
								"Content-Type": "application/json"
							}
						}).then(function(response){
							if (response.status == 200) {
								return response.json();
							}
						}, function(e){
							console.warn("ERROR...", e);
						}).then(function(json){
							if (json && json.valid) {
								this.checkSession();
							} else {
								this.$vBus.$emit("show-message", "Pasibaigė sesija...");
								console.warn("Pasibaigė sesija?.."); // TODO, FIXME!..
							}
						}.bind(this), function(e){
							console.warn("ERROR...", e);
						});
					}.bind(this), timeGap);
				}
			},
		},
		data: function(){
			var data = {
				mainComponent: null,
				mainComponentProperties: null,
				loginError: false
			};
			return data;
		},
		created(){
			/*
				http://localhost:8081/inspire-widgets/v2 (titulinis puslapis)
				http://localhost:8081/inspire-widgets/v2/my-content (vartotojo atlasai)
				http://localhost:8081/inspire-widgets/v2/admin (nžn)
				http://localhost:8081/inspire-widgets/v2/gallery (nžn, gal visų vartotojų vieši atlasai?)
				http://localhost:8081/inspire-widgets/v2/atlas (404 arba alt.: jei prisijungęs, redirect'as į "my-content", o jei nėra prisijungęs — redirect'as į "gallery")
				http://localhost:8081/inspire-widgets/v2/atlas/10 (atlaso `meta` puslapis)
				http://localhost:8081/inspire-widgets/v2/atlas/10/view (atlaso peržiūra)
				http://localhost:8081/inspire-widgets/v2/atlas/10/edit (atlaso redagavimas)
				// ---
				// http://apptest/inspire-widgets/v2/
			*/
			this.routeTo(this.$router.history.current.path);
			this.createSessionManager();
			// TODO:
			// ---
			// Redagavime pereinant tarp puslapių pranešti apie neišsaugotą turinį (jei kažkas tame puslapyje buvo keista!!!)
			// ---
			// Mano žemėlapio `2020-01-07` atidarymas! Neveikia zoom'inimo prie vektorinių sluoksnių mygtukas?! T. y. jis veikia, bet neturime sluoksnio aprėpties, tad ne'zoom'inama... Reikia besisukančio ratuko zoom'inimo mygtuko vietoje ir iš serviso gauti duomenų aprėptį??...
			// ---
			// Spausdinime realizuoti VSDS, RSDS spausdinimą.
			// ---
			// IE neveikia allSettled?
			// ---
			// Galimybė patogiai pereiti iš redagavimo į peržiūros režimą... Gal panašiaip kaip v1 buvo padaryta?
			// ---
			// Pamėgto serviso SINCHRONIZAVIMAS!!! Trys vietos: 1) paieškos rezultate, 2) sluoksnio info skiltyje, 3) filtravimas pagal pamėgtus
			// ---
			// http://kaukas:6080/arcgis/rest/services/geoportal_teikeju/LVI_Eko_zemelapis/MapServer nerodo legendos, nors MVPRO rodo?..
			// Identifikavimas...
			//  Galimybė identifikuoti FL, rastrus??... Dabar tik "AGS", "WMS" tipų sluoksniai identifikuojami...
			// Anoniminiams vartotojams (ar tiems vartotojams, ne kurių atlasą peržiūrime) pvz. https://apptest/inspire-widgets/v2/atlas/95ee6ccb-9ecf-4cbf-876c-95313a45ed33/view header'yje kelias turi būti specifinis? Gal koks Index -> Gallery -> Atlaso XXX peržiūra??...
			// ---
			// MD paieškoje select'ai... Lyg ir padaryti, bet grąžina mažiau rezultatų nei MVPRO??? Reikia testuoti paiešką! Galbūt problemos L. Dudučio serviso pusėje!
			// Pvz. neieško pagal tuos tiekėjus, kuriuose yra paprastos dvigubos kabutės?.. Pagal „“ lygtais ieško!
			// ---
			// Sesijos pratęsimas... Padarytas, bet ar veikia?
			// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
			// "Mano žemėlapių" (CIT2_MAP) pakrovimas... Kaip su apsaugotais servisais? Ar išlaikomas sluoksnių eiliškumas?.. Ar apsaugotų sluoksnių nebūna?... Kaip dėl service.attributes.serviceTitle??? Orig. MVPRO sluoksnių pavadinimai imami iš ten, o čia — ne
			// ---
			// Leisti kai kuriuos puslapius pasiekti visiems (ir neprisijungusiems) vartotojams... Kokie tai psl.? Galerija? "View" atlasas? Jei vartotojas neturi teisės peržiūrėti "View" atlaso? Kas tada?.. 
			// ---
			// Sluoksnio `meta` rodymas tame pačiame karuselės lygyje!!!
			// ---
			// IE mygtukuose blogai centruojasi icon'ėlės...
			// IE dialog'e "Atlaso meta" neužsifiksuoja "Pasirinkite reikšmę" pasirinkimas!
		},
		watch: {
			$route(to) {
				this.routeTo(to.path);
			}
		}
	};
</script>

<style>
	html, body {
		overflow: auto !important;
	}
	html.atlas, .atlas body {
		overflow: hidden !important;
		height: 100%;
	}
	div.ol-custom-overviewmap,
	div.ol-custom-overviewmap.ol-uncollapsible {
		bottom: auto;
		left: auto;
		right: 0;
		top: 0;
	}
	div.ol-custom-overviewmap:not(.ol-collapsed) {
		border: 1px solid black;
	}
	div.ol-custom-overviewmap div.ol-overviewmap-map {
		border: none;
		width: 300px;
	}
	div.ol-custom-overviewmap div.ol-overviewmap-box {
		border: 2px solid red;
	}
	div.ol-custom-overviewmap:not(.ol-collapsed) button {
		bottom: auto;
		left: auto;
		right: 1px;
		top: 1px;
	}
	.v-color-picker__controls {
		display: none !important;
	}
	.v-color-picker__swatches > div {
		justify-content: start !important;
		padding: 0 !important;
	}
	.clearable button {
		margin-top: 0 !important;
		font-size: 20px !important;
	}
	.v-treeview--dense .v-treeview-node__root {
		min-height: 34px !important;
	}
	.v-treeview-node__label {
		white-space: normal !important; /* Nes kitaip nusikerpa medis dešinėje didesnėse legendose */
	}
	.legend-row {
		display: table;
	}
	.legend-row span {
		display: table-cell;
		vertical-align: middle;
	}
	.legend-row img {
		display: block;
	}
	.legend-row em {
		font-style: normal;
		font-size: 0.8rem;
		padding-left: 3px;
		display: inline-block;
	}
	.v-treeview-node__root {
		align-items: start !important;
	}
	.one-level .v-treeview-node__level {
		display: none;
	}
	.one-level .v-treeview-node__root {
		padding-left: 0px !important;
	}

	/*

		Custom style for pages

	*/

	/*
		Main css changes
	*/
	.container-wrapper {
		/* TODO: pagalvoti apie gražesnę realizaciją */
		max-width: 1200px !important; 
	}

	.height-100 {
		height: 100vh;
	}

	/*
		Intro
	*/
	
	.intro-title {
		color: #e3e7ee;
		line-height: 1.3em;
		font-weight: 500;
		font-size: 50px;
	}

	/* 
		Navigation 
	*/
	#page-nav a {
		text-decoration: none;
		color: #505d63;
		padding-left: 10px;
	}

		#page-nav a:hover {
			color:rgba(50, 50, 50, 1);
		}
	
	.bg-color-dark {
		background-image: linear-gradient(180deg, rgba(27, 33, 41, 0.70), rgba(27, 33, 41, 0.50));
	}

	.atlas-gallery-image .v-image__image {
		filter: brightness(60%);
	}

	.navigation-main {
		position: absolute;
		top: 0;
		width: 100%;
	}

	.navigation-main a {
		text-decoration: none;
		color:rgba(50, 50, 50, 0.70);
		padding-left: 10px;
	}

		.navigation-main a:hover {
			color:rgba(50, 50, 50, 1);
		}

	/* 
		Landing-description
	*/

	.landing-description h3, .landing-description p {
		color: #505d63;
		line-height: 1.8em;
	}

		.landing-description h3 {
			font-size: 22px;
		}

		.landing-description p, .landing-description a {
			font-weight: 300;
			text-decoration: none;
		}

	.hero-links {
		line-height: 1.8em;
	}

	.background-dotted {
		background-image: url("assets/app/bg/dot-grid.png");
		background-repeat: repeat;
	}

	.help-description-vertical p, .help-description-vertical a {
		font-size: 0.85em;
	}

	#footer a {
		font-size: 0.85em;
		line-height: 2em;
		color:rgba(50, 50, 50, 0.70);
	}

		#footer a:hover {
			color:rgba(50, 50, 50, 1);
		}

</style>